import React, {Fragment, useEffect, useState} from 'react'
import {useDispatch} from "react-redux";
import './ReportCP_SpellCheck.scss'
import Modal from "../../../shared/component/Modal/Modal";
import SpellCheck from "../../../core/api/SpellCheck/SpellCheck";
import T from "../../../shared/component/t/T";
import StringDiff from "../../../shared/component/DiffComponents/StringDiffs";
import snippets from "../../../helpers/snippets";
import {_alert} from "../../../actions/Alert";
import {_loading} from "../../../actions/Loading";


const spellCheck = new SpellCheck()

const ReportCP_SpellCheck = (props) => {
    const dispatch = useDispatch();
	const [show, setShow] = useState(false)
	const [diffs, setDiffs] = useState({show: false, key: '', before: '', after: '', item: []})
	const [preview, setPreview] = useState({show: false, before: '', after: ''})
	
	const [report, setReport] = useState(props.NewStudyReport)
	const [suggestions, setSuggestions] = useState({})
	
	
	useEffect(() => {
		initial_suggestions()
	}, [])
	
	useEffect(() => {
		if (!snippets.isObjectEmpty(suggestions) || props.show === false)
			setShow(props.show)
	}, [props.show, suggestions]);
	
	
	const initial_suggestions = () => {
		dispatch(_loading(true));
		let data = {sentence: report?.findings}
		spellCheck.check(data)
			.then(response => {
				suggestionsHandler(response?.data?.suggestions)
				dispatch(_loading(false));
			}).catch((e)=> {
				console.error("spell check fetching failed", e)
				dispatch(_loading(false));
			})
	}
	
	const suggestionsHandler = (suggests) => {
		let obj = {}
		Object.entries(suggests).filter(([k, v])=> handleValues(k, v)).map(([key, value]) => (
				obj[key] = {list: handleValues(key, value), selected: {}}
		))
		if (snippets.isObjectEmpty(obj)) {
			dispatch(_alert(true, "success", <T token={"no_suggestion_alert"}/>));
			closeModal()
		} else
			setSuggestions(obj)
	}
	
	const handleValues = (key, value) => {
		let values = value?.filter(item => item.similarity >= 50)
		let valueNames = values?.map(item => item.name)
		if (values?.length > 0 && !valueNames?.includes(key)){
			return values
		}
	}
	
	const showSuggestions = (key, suggests) => {
		return suggests.list?.map(item => {
			let onClick, classNames
			if (suggestions[key]?.selected === item) {
				onClick = () => clearSelected(key)
				classNames = 'btn-success'
			} else {
				onClick = () => applySuggestionReplacement(key, item)
				classNames = 'btn-secondary'
			}
			
			return <>
				<button onClick={onClick}
				        type='button'
				        className={`btn px-1 mx-1 ${classNames}`}
				>
					{item?.name}
				</button>
			</>
		})
	}
	
	const replaceTextToWord = (text, targetWord, replacement) => {
		const regex = findExactMatchesRegExp(targetWord)
		return text.replace(regex, replacement);
	}
	
	const stringSlicing = (text, word, index, start, end = null) => {
		if (!end) end = start
		return text.slice(
			Math.max(0, index - start),
			Math.min(index + word.length + end, text.length))
	}
	
	const stringWordSlicing = (text, index, after, before = null) => {
		if (!before) before = after
		let resAfter = text.slice(index).split(" ", after).join(' ')
		let resBefore = text.slice(0, index).split('').reverse().join('').split(/\s+|\n/, before + 1)
			.join(' ').split('').reverse().join('');
		return resBefore + resAfter
	}
	
	const findExactMatchesRegExp = (targetWord) => {
		// in this function it replace a source with replace word even before and after that word be some symbols
		// for example if text be : "Hello.world, welcome to the newworld ....world."
		// and we want to replace "world" with "universe"
		// result would be : 'Hello.universe, welcome to the newworld ....universe.'
		
		// Using lookbehind and lookahead to ensure "اس" is a standalone word or followed/preceded by non-word characters
		// \p{Letter} matches any letter. The negative lookbehind (?<!\p{Letter}) and lookahead (?!\\p{Letter})
		// ensure the word is not part of another word.
		
		// return new RegExp(`(^|\\s)${source}(?=\\s|$)`, 'g')
		// return new RegExp(`(?<!\\p{Letter})${targetWord}(?!\\p{Letter})`, 'giu');
		return new RegExp(`(?<!\\p{Letter})${targetWord}(?!\\p{Letter})|(?<=\\p{Script=Arabic})${targetWord}`, 'giu');
	}
	
	const showKeyUsages = (key) => {
		const regexPattern = findExactMatchesRegExp(key);
		return [...report.findings.matchAll(regexPattern)]?.map(a => a.index)?.map(occ => {
			let text = stringWordSlicing(report?.findings, occ, 3, 1)
			return <div key={occ}
			            title={stringSlicing(report?.findings, key, occ, 5, 50)}
			            className={'d-flex justify-content-center flex-nowrap'}
			            dangerouslySetInnerHTML={{__html: makeItDifferent(text, key)}}
			/>
		})
	}
	
	const makeItDifferent = (text, word) => {
		let replaceWith = `<p class='text-decoration-underline px-1 m-0'> ${word} </p> `
		return replaceTextToWord(text, word, replaceWith)
	}
	
	const handleWhichKeysToShow = (key, value) => {
		return <tr key={key} className={'text-center align-middle'}>
			<td key={`${key}-item`}
			    className={''}
			>
				{key}
			</td>
			<td key={`${key}-usages`}
			    className={''}
			    style={{direction: 'rtl'}}
			>
				{showKeyUsages(key)}
			</td>
			<td key={`${key}-suggests`}>
				{showSuggestions(key, value)}
			</td>
		</tr>
	}
	
	const closeModal = () => {
		if (preview.show)
			closePreview()
		else
			props.closeModal()
	}
	
	const closePreview = () => {
		setPreview(prevState => ({...prevState, show: false}))
	}
	
	const clearSelected = (key) => {
		setSuggestions(prevState => ({...prevState, [key]: {...prevState[key], selected: {}}}))
	}
	
	const applySuggestionReplacement = (key, value) => {
		setSuggestions(prevState => ({...prevState, [key]: {...prevState[key], selected: value}}))
	}
	
	const showFinalPreview = () => {
		setPreview(prevState => ({
			...prevState,
			show: true,
			before: report.findings,
			after: currentFindings()
		}))
	}
	
	const afterReviewOK = ()=> {
		setPreview(prevState => ({
			...prevState,
			show: false,
			before: '',
			after: ''
		}))
		let obj = {...suggestions}
		Object.entries(obj).map(([key, value]) => (
			obj[key]={...value, selected: {}}
		))
		setSuggestions(obj)
	}
	
	const applyWholeReplacements = () => {
		afterReviewOK()
		props.changeFindings(preview.after)
		props.closeModal()
	}
	
	const footer = () => {
		let footerBody
		if (preview.show) {
			footerBody = <>
				<div className={'imodal__btn imodal__btn--primary'}
				     onClick={applyWholeReplacements}><T token={'apply_and_exit'}/>
				</div>
			</>
		} else if (show) {
			let suggestionExist = Object.entries(suggestions)
				.filter(([, value]) => !snippets.isObjectEmpty(value.selected))
				.map(([k,]) => k)
			if (!snippets.isObjectEmpty(suggestionExist)) {
				footerBody = <>
					<div className={'imodal__btn imodal__btn--primary'}
					     onClick={showFinalPreview}><T token={'preview'}/>
					</div>
				</>
			}
		}
		return <div className={'imodal__action '}>
			
			{footerBody}
			
			<div className={'imodal__btn imodal__btn--secondary'}
			     onClick={closeModal}><T token={(preview.show || diffs.show) ? 'return' : "cancel"}/>
			</div>
		</div>
	}
	
	const handleModalBody = () => {
		if (preview.show) {
			return <div className={'border rounded-1'}>
				<StringDiff before={preview.before}
				            after={preview.after}
				            direction={report?.direction}/>
			</div>
		} else if (show) {
			return <div className="table-responsive">
				<table className="table table-dark table-hover text-center">
					<thead>
					<tr>
						<th scope="col"><T token={'word'}/></th>
						<th scope="col"><T token={'usages'}/></th>
						<th scope="col"><T token={'suggestions'}/></th>
					</tr>
					</thead>
					<tbody>
						{Object.entries(suggestions)?.map(([k, v]) => handleWhichKeysToShow(k, v))}
					</tbody>
				</table>
			</div>
		}
	}
	
	const currentFindings = () => {
		let findings = report?.findings
		Object.entries(suggestions)?.filter(([, v]) => !snippets.isObjectEmpty(v.selected))
			.map(([key, value]) => {
				findings = replaceTextToWord(findings, key, value.selected.name)
			})
		return findings
	}
	
	return <>
		{show &&
			<Modal className="spell_check_modal"
			       title="spell_check_modal_title"
			       closeModal={closeModal}
			       footer={footer()}
			>
				<div className={'imodal spell_check'}>
					<div className={'imodal__body spell_check_body'}>
						{handleModalBody()}
					</div>
				</div>
			</Modal>
		}
	</>
}


export default ReportCP_SpellCheck;